import {
  UsersSelectionWidget,
  SiteSelectionWidget,
  VehicleSelectionWidget,
  TasksTypeSelectionWidget,
  TasksStatusSelectionWidget,
  OperationTypeSelectionWidget,
  WorkshopSelectionWidget,
  MaterialTypeSelectionWidget,
  ShiftTypeSelectionWidget,
  TariffSelectionWidget,
  VehicleTypeSelectionWidget,
} from 'components/FormWidgets';

const uiSchema = (startDisable, endDisable) => ({
  'ui:order': [
    'vehicle_ids',
    'site_ids',
    'workshop_ids',
    'driver_ids',
    'status_ids',
    'type_ids',
    'material_type_ids',
    'shift_type_ids',
    'tariff',
    '*',
  ],
  vehicle_ids: {
    'ui:widget': VehicleSelectionWidget,
    'ui:options': {
      initFilter: { type_ids: ['1', '2', '3', '4'] },
      xs: 6,
      sm: 6,
      md: 3,
      lg: 3,
      xl: 3,
    },
  },
  workshop_ids: {
    'ui:widget': WorkshopSelectionWidget,
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 3,
      lg: 3,
      xl: 3,
    },
  },
  site_ids: {
    'ui:widget': SiteSelectionWidget,
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 3,
      lg: 3,
      xl: 3,
    },
  },
  driver_ids: {
    'ui:widget': UsersSelectionWidget,
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 3,
      lg: 3,
      xl: 3,
    },
  },
  type_ids: {
    'ui:widget': TasksTypeSelectionWidget,
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 3,
      lg: 3,
      xl: 3,
    },
  },
  material_type_ids: {
    'ui:widget': MaterialTypeSelectionWidget,
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 3,
      lg: 3,
      xl: 3,
    },
  },
  shift_type_ids: {
    'ui:widget': ShiftTypeSelectionWidget,
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 3,
      lg: 3,
      xl: 3,
    },
  },
  operation_type_ids: {
    'ui:widget': OperationTypeSelectionWidget,
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 2,
      lg: 2,
      xl: 2,
    },
  },
  status_ids: {
    'ui:widget': TasksStatusSelectionWidget,
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 3,
      lg: 3,
      xl: 3,
    },
  },

  min_created_at: {
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 2.5,
      lg: 2.5,
      xl: 2.5,
    },
  },
  max_created_at: {
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 2.5,
      lg: 2.5,
      xl: 2.5,
    },
  },
  start_time: {
    'ui:disabled': startDisable,
    'ui:field': 'time',
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 2.5,
      lg: 2.5,
      xl: 2.5,
    },
  },
  end_time: {
    'ui:disabled': endDisable,
    'ui:field': 'time',
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 2.5,
      lg: 2.5,
      xl: 2.5,
    },
  },
  match_location: {
    'ui:widget': 'radio',
    'ui:options': {
      inline: true,
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  supervisor_ids: {
    'ui:widget': UsersSelectionWidget,
    'ui:options': {
      initFilter: { role_id: '8' },
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  vehicle_type_ids: {
    'ui:widget': VehicleTypeSelectionWidget,
    'ui:options': {
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
});

export default uiSchema;
